import * as React from 'react';
import { useField } from 'formik';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { hasValue } from './inputHelpers';
import CharacterCounter from './CharacterCounter';

interface IProps {
  name: string
  maxLength?: number
}

const XTextAreaInput = ({ name, onChange, maxLength, ...props }: TextFieldProps & IProps) => {
  const [field, meta] = useField({ name });
  const error = hasValue(meta.error) ? meta.error : undefined;
  const showError = Boolean(error && meta.touched);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(event);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <TextField
        {...field}
        {...props}
        fullWidth
        error={showError}
        helperText={showError && error}
        value={field.value || ''}
        multiline
        maxRows="4"
        rows={4}
        autoComplete="off"
        onChange={handleChange}
        inputProps={maxLength ? { ...props.inputProps, maxLength } : props.inputProps}
      />
      {
        maxLength && (
          <CharacterCounter
            currentLength={field.value?.length ?? 0}
            maxLength={maxLength}
          />
        )
      }
    </>
  );
};

export default XTextAreaInput;
